import { render, staticRenderFns } from "./PauseMenu.vue?vue&type=template&id=88f66a24&scoped=true&"
import script from "./PauseMenu.vue?vue&type=script&lang=js&"
export * from "./PauseMenu.vue?vue&type=script&lang=js&"
import style0 from "./PauseMenu.vue?vue&type=style&index=0&id=88f66a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f66a24",
  null
  
)

export default component.exports